import { ICountry } from "../models/Country";
import { ICurrency } from "../models/Currency";
import { Int32Value } from 'google-protobuf/google/protobuf/wrappers_pb';

// same as the one used in variables.scss
export const MOBILE_WIDTH = 768;

export function isMobile() {
  if (window.innerWidth <= MOBILE_WIDTH) {
    return true;
  }
  return false;
}

export function debounce(this: any, fn: Function, delay: number = 500) {
  let timeout: any = -1;
  const currentScope = this;
  return function (...args: any[]) {
    clearTimeout(timeout);
    timeout = setTimeout(fn.bind(currentScope, ...args), delay);
  }
}

/**
 * reorder the countries putting on top USA, UK, AUSTRALIA, CANADA
 * @param countries 
 */
export function reorderCountries(countries: Array<ICountry>): Array<ICountry> {
  const USA = countries.splice(countries.findIndex(country => country.iso3Code === "USA"), 1);
  const UK = countries.splice(countries.findIndex(country => country.iso3Code === "GBR"), 1);
  const AUSTRALIA = countries.splice(countries.findIndex(country => country.iso3Code === "AUS"), 1);
  const CANADA = countries.splice(countries.findIndex(country => country.iso3Code === "CAN"), 1);
  countries.unshift(...USA.concat(UK).concat(AUSTRALIA).concat(CANADA));
  return countries;
}
/**
 * reorder the currencies putting on top US$, £, AUS$, CAN$
 * @param currencies 
 */
export function reorderCurrencies(currencies: Array<ICurrency>): Array<ICurrency> {
  const USA = currencies.splice(currencies.findIndex(currency => currency.isoCode === "USD"), 1);
  const UK = currencies.splice(currencies.findIndex(currency => currency.isoCode === "GBP"), 1);
  const AUSTRALIA = currencies.splice(currencies.findIndex(currency => currency.isoCode === "AUD"), 1);
  const CANADA = currencies.splice(currencies.findIndex(currency => currency.isoCode === "CAD"), 1);
  currencies.unshift(...USA.concat(UK).concat(AUSTRALIA).concat(CANADA));
  return currencies;
}



/**
 * copy a text to the clipboard
 */
export function copyToClipboard(text: string) {
  var id = "mycustom-clipboard-textarea-hidden-id";
  var existsTextarea = document.getElementById(id) as HTMLTextAreaElement;

  if (!existsTextarea) {
    let textarea = document.createElement("textarea") as HTMLTextAreaElement;
    textarea.id = id;
    // Place in top-left corner of screen regardless of scroll position.
    textarea.style.position = 'fixed';
    textarea.style.top = "0";
    textarea.style.left = "0";

    // Ensure it has a small width and height. Setting to 1px / 1em
    // doesn't work as this gives a negative w/h on some browsers.
    textarea.style.width = '1px';
    textarea.style.height = '1px';

    // We don't need padding, reducing the size if it does flash render.
    textarea.style.padding = "0";

    // Clean up any borders.
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';

    // Avoid flash of white box if rendered for any reason.
    textarea.style.background = 'transparent';
    const body = document.querySelector("body");
    if (!body) {
      return;
    }
    body.appendChild(textarea);
    existsTextarea = document.getElementById(id) as HTMLTextAreaElement;
  }

  existsTextarea.value = text;
  existsTextarea.select();

  try {
    var status = document.execCommand('copy');
  } catch (err) {
    console.log('Unable to copy.');
  }
}


/**
 * utility to multiply any number value by a 100 preserving the decimals
 * @param value 
 */
export function multiplyNumberBy100<T>(value?: T): T | undefined {
  if (!value) { return }
  if (!(value as any as Int32Value).getValue) {
    //treat it like a number primitive
    return Math.round(Number(value) * 100) as any as T;
  }
  const newVal = (value as any as Int32Value).getValue();
  const newValBy100 = new Int32Value();
  newValBy100.setValue(Math.round(newVal * 100));
  return newValBy100 as any as T;
}

/**
 * utility to divide any number value by a 100 preserving the decimals
 * @param value 
 */
export function divideNumberBy100<T>(value?: T): T | undefined {
  if (value === undefined || value === null) { return }
  if (!(value as any as Int32Value).getValue) {
    //treat it like a number primitive
    return Number(value) / 100 as any as T;
  }
  const newVal = (value as any as Int32Value).getValue();
  const newValDivideBy100 = new Int32Value();
  newValDivideBy100.setValue(newVal / 100);
  return newValDivideBy100 as any as T;
}

export const extractGrpcErrorMessage = (message: string) => {
  const fromWord = "ErrorMessage: "
  return message.split(fromWord).pop();
}


export const allowNumberMoreThanZero = (input?: string) => {
  if (!!input && Number(input) > 0)
    return +input;

  return undefined;
}

export const allowZeroAndPositiveNumbers = (input?: string) => {
  if (!!input && Number(input) >= 0)
    return +input;

  return undefined;
}
